// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__kB7zi","col":"styles_col__TLCif"};